import cookie from 'js-cookie';

export const getAnonId = () => cookie.get('shd') || '';
export const getUserAccountId = () => cookie.get('user_account_id') || '';
